import React from "react"
import styled from "styled-components"
import { Field, FieldProps } from "react-final-form"

import { FontConfigurations, typography } from "theme"
import { DefaultField, DefaultFieldProps } from "components/form/shared/default-field"
import { INPUT_CSS } from "components/form/shared/default-field/styles"
import { getValidator } from "components/form"

export const TextArea = styled.textarea.attrs({
  ...FontConfigurations.p
})`
  /*
    For the textarea there's no "floating up" label so the placeholder is shown.
    We can't target the placeholder via styled-system props sowe need to pass the label styles directly
  */
  ::placeholder {
    font-family: ${props => props.theme.fonts.paragraph};
    font-weight: lighter;
  }

  ${INPUT_CSS}
  ${typography}
`

export function TextAreaField(props: FieldProps<string, HTMLInputElement>) {
  const validate = getValidator(props.validate, props.required)

  return (
    <Field InputComponent={TextArea} pr={0} {...props} validate={validate}>
      {(inputProps: DefaultFieldProps<string>) => <DefaultField {...inputProps} />}
    </Field>
  )
}
